
        var result = require("!!../../../../node_modules/css-loader/index.js!./customer.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/customers/customer/customer.component.css
// module id = 2486
// module chunks = 1